import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVeritasComponent } from './simple-icons-veritas.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVeritasComponent ],
    exports:      [ SimpleIconsVeritasComponent ],
    bootstrap:    []
})
export class SimpleIconsVeritasModule {}
